module.exports = __webpack_public_path__ + "img/logo_MAJESTY.098c48be.png";